import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-optimize-dialog',
  templateUrl: './optimize-dialog.component.html',
  styleUrls: ['./optimize-dialog.component.scss']
})
export class OptimizeDialogComponent implements OnInit {
type: string;

@Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    public dialogRef: MatDialogRef<OptimizeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.type = data.type;
    }

  ngOnInit() {
  }

  ok() {
    this.action.emit(true);
    this.onCloseDialog();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/efficiency/redy-tips/optimize-dialog/optimize-dialog.component.ts